

const Details = () => {
    return (
        <div style={{ background: '#e7f3fe', padding: '3px 5px 5px 5px' }}>
            <p style={{ marginBottom: '5px' }}><strong>For Assistance please contact us at info@tmdsas.com or +1 512 499 4785</strong></p>
            <ul style={{ listStyleType: 'disc', paddingLeft: '25px' }}>
                <li>Hours of operation: Monday – Friday, 9 AM – 12 PM and 1 PM - 4 PM CST.</li>
                <li>We typically provide responses to messages within 1-2 business days</li>
                <li>response times can be longer during peak season (May - July). Be sure to have your TMDSAS ID number (located under your name in the upper-right corner of any of our web applications) when contacting TMDSAS / JAMP / TXHES.</li>
            </ul>

        </div>
    );
};
export default Details;
